import { IMessage } from '@weblite/ts-action/message'
import { useRoom } from '$logic/room/react-hook'
import { useWapp } from '$logic/wapps/react-hook'
import { useWappRoom } from '$logic/wapp-room/react-hook'
import { getImageUrl } from '$func/imageUrl'
import { useRoomLastMessage } from '$logic/room-last-message/react-hook'
import { EventTitle } from '$common/chat-list-item-new/components/event-title'
import { SelectableAvatar } from '$common/avatar'
import { getAvatarText } from '$func/avatar-text'
import { ChatListItemBase } from './chat-list-item-base'
import { ChatListItemSkeleton } from './chat-list-item-skeleton'
import { ChatListItemProps } from './chat-list-item.types'
import {
  getLastMessageStatus,
  getLastMessageText,
} from './hooks/chat-list-item-hooks'
import { AvatarSize } from '$common/avatar/avatar-base/types'

export function WappRoomChatListItem({
  chatId,
  pinned,
  isOnTop,
  selected,
  onClick,
  onContextMenu,
  onLongPress,
  isOpened,
}: ChatListItemProps) {
  const room = useRoom(chatId)
  const { entity: wappRoom, loading: wappRoomLoading } = useWappRoom(chatId)

  const { entity: wapp, loading: wappLoading } = useWapp(wappRoom?.wappId || '')
  const lastMessage = useRoomLastMessage(chatId)

  if (wappRoomLoading || wappLoading) return <ChatListItemSkeleton />
  if (!wappRoom || !wapp) return null

  const { unseen, seen, received, fromMe } = getLastMessageStatus(
    lastMessage,
    wappRoom.seen,
    room,
  )

  return (
    <ChatListItemBase
      chatId={chatId}
      avatarElement={
        <SelectableAvatar
          checked={selected}
          src={getImageUrl(wapp?.image)}
          avatarBackgroundText={getAvatarText(wapp?.name)}
          size={AvatarSize.LG}
        />
      }
      selected={selected}
      title={wapp?.name}
      date={lastMessage?.date}
      lastMessageType={lastMessage?.type}
      lastMessageBody={getLastMessageText(lastMessage) || ''}
      unseen={unseen}
      seen={Boolean(seen)}
      received={Boolean(received)}
      muted={wappRoom?.muted}
      fromMe={fromMe}
      pinned={pinned}
      verified={wapp?.verified}
      hasMarkAsUnread={wappRoom.unreadMark}
      eventTitle={<EventTitle lastMessage={lastMessage as IMessage} />}
      isOnTop={isOnTop}
      onClick={onClick}
      onContextMenu={onContextMenu}
      onLongPress={onLongPress}
      links={(lastMessage as IMessage)?.links}
      roomType="WAPP_ROOM"
      isOpened={isOpened}
    />
  )
}
